// This file is generated by pnpm icons:generate. Do not edit.

import {ArrowCornerDownRight_Stroke2_Corner2_Rounded as CanonicalArrowCornerDownRight_Stroke2_Corner2_Rounded} from './Arrow'
import {ArrowCornerDownRight_Stroke2_Corner3_Rounded as CanonicalArrowCornerDownRight_Stroke2_Corner3_Rounded} from './Arrow'

/** @deprecated Import ArrowCornerDownRight_Stroke2_Corner2_Rounded from `#/components/icons/Arrow` instead. */
export const ArrowCornerDownRight_Stroke2_Corner2_Rounded =
  CanonicalArrowCornerDownRight_Stroke2_Corner2_Rounded

/** @deprecated Import ArrowCornerDownRight_Stroke2_Corner3_Rounded from `#/components/icons/Arrow` instead. */
export const ArrowCornerDownRight_Stroke2_Corner3_Rounded =
  CanonicalArrowCornerDownRight_Stroke2_Corner3_Rounded
